export default __webpack_public_path__ + "static/media/dynamic_grid.2426da10.svg";